/**
 * JWAY ICONS SET
 */

export interface IconProps {
  color?: string;
  size?: number;
}

export type IconType =
  | "home"
  | "coin"
  | "electricStation"
  | "peoples"
  | "building"
  | "profil"
  | "bell"
  | "link-crooked"
  | "copy"
  | "visibility-off"
  | "admin"
  | "visibility"
  | "thunder"
  | "plus-in-cercle"
  | "electric-car-plug"
  | "ship"
  | "search"
  | "trash"
  | "edit-sheet"
  | "prohibited"
  | "more-element"
  | "time"
  | "info"
  | "filter"
  | "cross"
  | "people-star"
  | "wallet"
  | "exchange"
  | "plus"
  | "arrow-right"
  | "plug-icon"
  | "download-icon"
  | "car-plug-type-2"
  | "car-plug-ccs2"
  | "exit"
  | "ef-plug"
  | "chart-in-box"
  ;
export const HomeIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 13C0.89543 13 0 12.1046 0 11V5.35596C0 4.71375 0.308394 4.1106 0.829019 3.7346L4.82902 0.845709C5.52805 0.340853 6.47195 0.340853 7.17098 0.845709L11.171 3.7346C11.6916 4.1106 12 4.71375 12 5.35596V11C12 12.1046 11.1046 13 10 13H9.5C8.39543 13 7.5 12.1046 7.5 11V9.44444C7.5 8.61602 6.82843 7.94444 6 7.94444V7.94444C5.17157 7.94444 4.5 8.61602 4.5 9.44444V11C4.5 12.1046 3.60457 13 2.5 13H2Z"
      fill={color}
    />
  </svg>
);

export const ArrowRightIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.451987 1.58023L1.51299 0.520235L7.29199 6.29723C7.38514 6.3898 7.45907 6.49988 7.50952 6.62113C7.55997 6.74238 7.58594 6.87241 7.58594 7.00373C7.58594 7.13506 7.55997 7.26509 7.50952 7.38634C7.45907 7.50759 7.38514 7.61767 7.29199 7.71023L1.51299 13.4902L0.452987 12.4302L5.87699 7.00523L0.451987 1.58023Z"
      fill={color}
    />
  </svg>
);

export const CarPlugIconCCS2 = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 18C5.5 18.8 4.8 19.5 4 19.5C3.2 19.5 2.5 18.8 2.5 18C2.5 17.2 3.2 16.5 4 16.5C4.8 16.5 5.5 17.2 5.5 18ZM16 16.5C15.2 16.5 14.5 17.2 14.5 18C14.5 18.8 15.2 19.5 16 19.5C16.8 19.5 17.5 18.8 17.5 18C17.5 17.2 16.8 16.5 16 16.5ZM16 14H15.7C17.7 12.4 19 9.8 19 7C19 4.2 17.7 1.6 15.7 0H4.3C2.3 1.6 1 4.2 1 7C1 9.8 2.3 12.4 4.3 14H4C1.8 14 0 15.8 0 18C0 20.2 1.8 22 4 22H16C18.2 22 20 20.2 20 18C20 15.8 18.2 14 16 14ZM3 7C3 5.1 3.8 3.3 5.1 2H14.9C16.2 3.3 17 5.1 17 7C17 10.9 13.9 14 10 14C6.1 14 3 10.9 3 7ZM16 20H4C2.9 20 2 19.1 2 18C2 16.9 2.9 16 4 16H16C17.1 16 18 16.9 18 18C18 19.1 17.1 20 16 20ZM10.9 4.3C10.9 5 11.5 5.6 12.2 5.6C12.9 5.6 13.5 5 13.5 4.3C13.5 3.6 12.9 3 12.1 3C11.4 3 10.9 3.6 10.9 4.3ZM6.6 4.3C6.6 5 7.2 5.6 7.9 5.6C8.6 5.6 9.2 5 9.2 4.3C9.2 3.6 8.6 3 7.9 3C7.1 3 6.6 3.6 6.6 4.3ZM5.7 9C6.7 9 7.4 8.2 7.4 7.3C7.4 6.4 6.6 5.6 5.7 5.6C4.8 5.6 4 6.3 4 7.3C4 8.2 4.8 9 5.7 9ZM9.6 10.7C9.6 9.8 8.8 9 7.9 9C6.9 9 6.2 9.8 6.2 10.7C6.2 11.7 7 12.4 7.9 12.4C8.8 12.4 9.6 11.7 9.6 10.7ZM10 9C11 9 11.7 8.2 11.7 7.3C11.7 6.4 10.9 5.6 10 5.6C9.1 5.6 8.3 6.4 8.3 7.3C8.3 8.2 9.1 9 10 9ZM13.9 10.7C13.9 9.8 13.1 9 12.2 9C11.2 9 10.5 9.8 10.5 10.7C10.5 11.7 11.3 12.4 12.2 12.4C13.1 12.4 13.9 11.7 13.9 10.7ZM16 7.3C16 6.4 15.2 5.6 14.3 5.6C13.3 5.6 12.6 6.4 12.6 7.3C12.6 8.3 13.4 9 14.3 9C15.2 9 16 8.2 16 7.3Z"
      fill={color}
    />
  </svg>
);

export const CarPlugIconType2 = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3 2C17 3.5 18 5.6 18 8C18 12.4 14.4 16 10 16C5.6 16 2 12.4 2 8C2 5.6 3.1 3.5 4.7 2H15.3ZM16 0H4L3.4 0.5C1.2 2.4 0 5.1 0 8C0 13.5 4.5 18 10 18C15.5 18 20 13.5 20 8C20 5.1 18.8 2.4 16.6 0.5L16 0ZM11 4.5C11 5.3 11.7 6 12.5 6C13.3 6 14 5.3 14 4.5C14 3.7 13.3 3 12.5 3C11.7 3 11 3.7 11 4.5ZM6 4.5C6 5.3 6.7 6 7.5 6C8.3 6 9 5.3 9 4.5C9 3.7 8.3 3 7.5 3C6.7 3 6 3.7 6 4.5ZM5 10C6.1 10 7 9.1 7 8C7 6.9 6.1 6 5 6C3.9 6 3 6.9 3 8C3 9.1 3.9 10 5 10ZM9.5 12C9.5 10.9 8.6 10 7.5 10C6.4 10 5.5 10.9 5.5 12C5.5 13.1 6.4 14 7.5 14C8.6 14 9.5 13.1 9.5 12ZM10 10C11.1 10 12 9.1 12 8C12 6.9 11.1 6 10 6C8.9 6 8 6.9 8 8C8 9.1 8.9 10 10 10ZM14.5 12C14.5 10.9 13.6 10 12.5 10C11.4 10 10.5 10.9 10.5 12C10.5 13.1 11.4 14 12.5 14C13.6 14 14.5 13.1 14.5 12ZM17 8C17 6.9 16.1 6 15 6C13.9 6 13 6.9 13 8C13 9.1 13.9 10 15 10C16.1 10 17 9.1 17 8Z"
      fill={color}
    />
  </svg>
);

export const CarPlugIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 18C5.5 18.8 4.8 19.5 4 19.5C3.2 19.5 2.5 18.8 2.5 18C2.5 17.2 3.2 16.5 4 16.5C4.8 16.5 5.5 17.2 5.5 18ZM16 16.5C15.2 16.5 14.5 17.2 14.5 18C14.5 18.8 15.2 19.5 16 19.5C16.8 19.5 17.5 18.8 17.5 18C17.5 17.2 16.8 16.5 16 16.5ZM16 14H15.7C17.7 12.4 19 9.8 19 7C19 4.2 17.7 1.6 15.7 0H4.3C2.3 1.6 1 4.2 1 7C1 9.8 2.3 12.4 4.3 14H4C1.8 14 0 15.8 0 18C0 20.2 1.8 22 4 22H16C18.2 22 20 20.2 20 18C20 15.8 18.2 14 16 14ZM3 7C3 5.1 3.8 3.3 5.1 2H14.9C16.2 3.3 17 5.1 17 7C17 10.9 13.9 14 10 14C6.1 14 3 10.9 3 7ZM16 20H4C2.9 20 2 19.1 2 18C2 16.9 2.9 16 4 16H16C17.1 16 18 16.9 18 18C18 19.1 17.1 20 16 20ZM10.9 4.3C10.9 5 11.5 5.6 12.2 5.6C12.9 5.6 13.5 5 13.5 4.3C13.5 3.6 12.9 3 12.1 3C11.4 3 10.9 3.6 10.9 4.3ZM6.6 4.3C6.6 5 7.2 5.6 7.9 5.6C8.6 5.6 9.2 5 9.2 4.3C9.2 3.6 8.6 3 7.9 3C7.1 3 6.6 3.6 6.6 4.3ZM5.7 9C6.7 9 7.4 8.2 7.4 7.3C7.4 6.4 6.6 5.6 5.7 5.6C4.8 5.6 4 6.3 4 7.3C4 8.2 4.8 9 5.7 9ZM9.6 10.7C9.6 9.8 8.8 9 7.9 9C6.9 9 6.2 9.8 6.2 10.7C6.2 11.7 7 12.4 7.9 12.4C8.8 12.4 9.6 11.7 9.6 10.7ZM10 9C11 9 11.7 8.2 11.7 7.3C11.7 6.4 10.9 5.6 10 5.6C9.1 5.6 8.3 6.4 8.3 7.3C8.3 8.2 9.1 9 10 9ZM13.9 10.7C13.9 9.8 13.1 9 12.2 9C11.2 9 10.5 9.8 10.5 10.7C10.5 11.7 11.3 12.4 12.2 12.4C13.1 12.4 13.9 11.7 13.9 10.7ZM16 7.3C16 6.4 15.2 5.6 14.3 5.6C13.3 5.6 12.6 6.4 12.6 7.3C12.6 8.3 13.4 9 14.3 9C15.2 9 16 8.2 16 7.3Z"
      fill={color}
    />
  </svg>
);

export const PeopleStarIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.66675 2.66669C7.66675 1.37803 6.62206 0.333374 5.3334 0.333374L5.20537 0.336812C3.97625 0.40328 3.00006 1.421 3.00006 2.66669C3.00006 3.95537 4.04475 5.00003 5.3334 5.00003L5.46144 4.99656C6.69056 4.93012 7.66675 3.91241 7.66675 2.66669ZM6.00006 10.3334C6.00006 11.0619 6.19484 11.745 6.53519 12.3334H0.666748V9.93337C0.666748 7.99484 2.15637 6.41419 4.02247 6.33637L4.16672 6.33337H6.50006C7.10737 6.33337 7.67856 6.49247 8.17637 6.77234C6.88422 7.43544 6.00006 8.78116 6.00006 10.3334ZM8.04078 13.0301L10.0001 11.8334L11.9593 13.0301L11.4267 10.7969L13.1702 9.30331L10.8817 9.11984L10.0001 7.00003L9.11837 9.11984L6.82987 9.30331L8.57347 10.7969L8.04078 13.0301Z"
      fill={color}
    />
  </svg>
);

export const PlusIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill={color} />
  </svg>
);

export const ExchangeIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9982 5.00409C15.9982 4.73888 15.8928 4.48452 15.7053 4.29699C15.5178 4.10945 15.2634 4.00409 14.9982 4.00409H3.40819L5.70819 1.71409C5.89649 1.52579 6.00228 1.27039 6.00228 1.00409C6.00228 0.73779 5.89649 0.482395 5.70819 0.294092C5.51988 0.105788 5.26449 1.9841e-09 4.99819 0C4.73188 -1.9841e-09 4.47649 0.105788 4.28819 0.294092L0.288186 4.29409C0.149429 4.43472 0.0554325 4.61329 0.0180584 4.80728C-0.0193158 5.00127 0.0016069 5.20198 0.0781863 5.38409C0.153206 5.56671 0.280604 5.72304 0.444325 5.83337C0.608045 5.9437 0.800761 6.00311 0.998186 6.00409H14.9982C15.2634 6.00409 15.5178 5.89873 15.7053 5.7112C15.8928 5.52366 15.9982 5.26931 15.9982 5.00409ZM19.9182 8.62409C19.8432 8.44147 19.7158 8.28515 19.552 8.17481C19.3883 8.06448 19.1956 8.00508 18.9982 8.00409H4.99819C4.73297 8.00409 4.47862 8.10945 4.29108 8.29699C4.10354 8.48452 3.99819 8.73887 3.99819 9.00409C3.99819 9.26931 4.10354 9.52366 4.29108 9.7112C4.47862 9.89874 4.73297 10.0041 4.99819 10.0041H16.5882L14.2882 12.2941C14.1945 12.3871 14.1201 12.4977 14.0693 12.6195C14.0185 12.7414 13.9924 12.8721 13.9924 13.0041C13.9924 13.1361 14.0185 13.2668 14.0693 13.3887C14.1201 13.5105 14.1945 13.6211 14.2882 13.7141C14.3812 13.8078 14.4917 13.8822 14.6136 13.933C14.7355 13.9838 14.8662 14.0099 14.9982 14.0099C15.1302 14.0099 15.2609 13.9838 15.3828 13.933C15.5046 13.8822 15.6152 13.8078 15.7082 13.7141L19.7082 9.71409C19.8469 9.57347 19.9409 9.39489 19.9783 9.2009C20.0157 9.00692 19.9948 8.8062 19.9182 8.62409Z"
      fill={color}
    />
  </svg>
);

export const WalletIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.125 0C0.826631 0 0.540483 0.131696 0.329505 0.366117C0.118526 0.600537 0 0.918479 0 1.25L0 2.91667H4.5C4.59946 2.91667 4.69484 2.96057 4.76516 3.03871C4.83549 3.11685 4.875 3.22283 4.875 3.33333C4.875 3.54417 4.935 3.87 5.1045 4.13167C5.25975 4.37167 5.52225 4.58333 6 4.58333C6.47775 4.58333 6.74025 4.37167 6.8955 4.13167C7.065 3.87 7.125 3.54417 7.125 3.33333C7.125 3.22283 7.16451 3.11685 7.23483 3.03871C7.30516 2.96057 7.40054 2.91667 7.5 2.91667H12V1.25C12 0.918479 11.8815 0.600537 11.6705 0.366117C11.4595 0.131696 11.1734 0 10.875 0H1.125Z"
      fill={color}
    />
    <path
      d="M12 3.75H7.83675C7.78248 4.06228 7.66924 4.35823 7.5045 4.61833C7.20975 5.07333 6.72225 5.41667 6 5.41667C5.27775 5.41667 4.79025 5.07333 4.4955 4.61833C4.33076 4.35823 4.21752 4.06228 4.16325 3.75H0V8.75C0 9.08152 0.118526 9.39946 0.329505 9.63388C0.540483 9.8683 0.826631 10 1.125 10H10.875C11.1734 10 11.4595 9.8683 11.6705 9.63388C11.8815 9.39946 12 9.08152 12 8.75V3.75Z"
      fill={color}
    />
  </svg>
);

export const CrossIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 17L1 1M17 1L1 17"
      stroke={color}
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);

export const ShipIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.75 4H4.25C4.11193 4 4 4.11193 4 4.25V9.75C4 9.88807 4.11193 10 4.25 10H9.75C9.88807 10 10 9.88807 10 9.75V4.25C10 4.11193 9.88807 4 9.75 4Z"
      fill={color}
    />
    <path
      d="M13.5 5C13.6326 5 13.7598 4.94732 13.8536 4.85355C13.9473 4.75979 14 4.63261 14 4.5C14 4.36739 13.9473 4.24021 13.8536 4.14645C13.7598 4.05268 13.6326 4 13.5 4H13V3C12.9994 2.46974 12.7885 1.96137 12.4136 1.58643C12.0386 1.21148 11.5303 1.00058 11 1H10V0.5C10 0.367392 9.94732 0.240215 9.85355 0.146447C9.75979 0.0526784 9.63261 0 9.5 0C9.36739 0 9.24021 0.0526784 9.14645 0.146447C9.05268 0.240215 9 0.367392 9 0.5V1H7.5V0.5C7.5 0.367392 7.44732 0.240215 7.35355 0.146447C7.25979 0.0526784 7.13261 0 7 0C6.86739 0 6.74021 0.0526784 6.64645 0.146447C6.55268 0.240215 6.5 0.367392 6.5 0.5V1H5V0.5C5 0.367392 4.94732 0.240215 4.85355 0.146447C4.75979 0.0526784 4.63261 0 4.5 0C4.36739 0 4.24021 0.0526784 4.14645 0.146447C4.05268 0.240215 4 0.367392 4 0.5V1H3C2.46974 1.00058 1.96137 1.21148 1.58643 1.58643C1.21148 1.96137 1.00058 2.46974 1 3V4H0.5C0.367392 4 0.240215 4.05268 0.146447 4.14645C0.0526784 4.24021 0 4.36739 0 4.5C0 4.63261 0.0526784 4.75979 0.146447 4.85355C0.240215 4.94732 0.367392 5 0.5 5H1V6.5H0.5C0.367392 6.5 0.240215 6.55268 0.146447 6.64645C0.0526784 6.74021 0 6.86739 0 7C0 7.13261 0.0526784 7.25979 0.146447 7.35355C0.240215 7.44732 0.367392 7.5 0.5 7.5H1V9H0.5C0.367392 9 0.240215 9.05268 0.146447 9.14645C0.0526784 9.24021 0 9.36739 0 9.5C0 9.63261 0.0526784 9.75979 0.146447 9.85355C0.240215 9.94732 0.367392 10 0.5 10H1V11C1.00058 11.5303 1.21148 12.0386 1.58643 12.4136C1.96137 12.7885 2.46974 12.9994 3 13H4V13.5C4 13.6326 4.05268 13.7598 4.14645 13.8536C4.24021 13.9473 4.36739 14 4.5 14C4.63261 14 4.75979 13.9473 4.85355 13.8536C4.94732 13.7598 5 13.6326 5 13.5V13H6.5V13.5C6.5 13.6326 6.55268 13.7598 6.64645 13.8536C6.74021 13.9473 6.86739 14 7 14C7.13261 14 7.25979 13.9473 7.35355 13.8536C7.44732 13.7598 7.5 13.6326 7.5 13.5V13H9V13.5C9 13.6326 9.05268 13.7598 9.14645 13.8536C9.24021 13.9473 9.36739 14 9.5 14C9.63261 14 9.75979 13.9473 9.85355 13.8536C9.94732 13.7598 10 13.6326 10 13.5V13H11C11.5303 12.9994 12.0386 12.7885 12.4136 12.4136C12.7885 12.0386 12.9994 11.5303 13 11V10H13.5C13.6326 10 13.7598 9.94732 13.8536 9.85355C13.9473 9.75979 14 9.63261 14 9.5C14 9.36739 13.9473 9.24021 13.8536 9.14645C13.7598 9.05268 13.6326 9 13.5 9H13V7.5H13.5C13.6326 7.5 13.7598 7.44732 13.8536 7.35355C13.9473 7.25979 14 7.13261 14 7C14 6.86739 13.9473 6.74021 13.8536 6.64645C13.7598 6.55268 13.6326 6.5 13.5 6.5H13V5H13.5ZM11 10C11 10.2652 10.8946 10.5196 10.7071 10.7071C10.5196 10.8946 10.2652 11 10 11H4C3.73478 11 3.48043 10.8946 3.29289 10.7071C3.10536 10.5196 3 10.2652 3 10V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H10C10.2652 3 10.5196 3.10536 10.7071 3.29289C10.8946 3.48043 11 3.73478 11 4V10Z"
      fill={color}
    />
  </svg>
);

export const ThunderIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 12 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 14H0L7 0V8H12L5 22V14Z" fill={color} />
  </svg>
);

export const CoinIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 16C3.5816 16 0 12.4184 0 8C0 3.5816 3.5816 0 8 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8 16ZM5.2 9.6V11.2H7.2V12.8H8.8V11.2H9.6C10.1304 11.2 10.6391 10.9893 11.0142 10.6142C11.3893 10.2391 11.6 9.73043 11.6 9.2C11.6 8.66957 11.3893 8.16086 11.0142 7.78579C10.6391 7.41071 10.1304 7.2 9.6 7.2H6.4C6.29391 7.2 6.19217 7.15786 6.11716 7.08284C6.04214 7.00783 6 6.90609 6 6.8C6 6.69391 6.04214 6.59217 6.11716 6.51716C6.19217 6.44214 6.29391 6.4 6.4 6.4H10.8V4.8H8.8V3.2H7.2V4.8H6.4C5.86957 4.8 5.36086 5.01071 4.98579 5.38579C4.61071 5.76086 4.4 6.26957 4.4 6.8C4.4 7.33043 4.61071 7.83914 4.98579 8.21421C5.36086 8.58929 5.86957 8.8 6.4 8.8H9.6C9.70609 8.8 9.80783 8.84214 9.88284 8.91716C9.95786 8.99217 10 9.09391 10 9.2C10 9.30609 9.95786 9.40783 9.88284 9.48284C9.80783 9.55786 9.70609 9.6 9.6 9.6H5.2Z"
      fill={color}
    />
  </svg>
);

export const ProhibitedIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C15.5 0 20 4.5 20 10C20 15.5 15.5 20 10 20C4.5 20 0 15.5 0 10C0 4.5 4.5 0 10 0ZM10 2C8.1 2 6.4 2.6 5.1 3.7L16.3 14.9C17.3 13.5 18 11.8 18 10C18 5.6 14.4 2 10 2ZM14.9 16.3L3.7 5.1C2.6 6.4 2 8.1 2 10C2 14.4 5.6 18 10 18C11.9 18 13.6 17.4 14.9 16.3Z"
      fill={color}
    />
  </svg>
);

export const FilterIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H17C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1C18 1.26522 17.8946 1.51957 17.7071 1.70711C17.5196 1.89464 17.2652 2 17 2H1C0.734784 2 0.48043 1.89464 0.292893 1.70711C0.105357 1.51957 0 1.26522 0 1ZM2 5.5C2 5.23478 2.10536 4.98043 2.29289 4.79289C2.48043 4.60536 2.73478 4.5 3 4.5H15C15.2652 4.5 15.5196 4.60536 15.7071 4.79289C15.8946 4.98043 16 5.23478 16 5.5C16 5.76522 15.8946 6.01957 15.7071 6.20711C15.5196 6.39464 15.2652 6.5 15 6.5H3C2.73478 6.5 2.48043 6.39464 2.29289 6.20711C2.10536 6.01957 2 5.76522 2 5.5ZM5 10C5 9.73478 5.10536 9.48043 5.29289 9.29289C5.48043 9.10536 5.73478 9 6 9H12C12.2652 9 12.5196 9.10536 12.7071 9.29289C12.8946 9.48043 13 9.73478 13 10C13 10.2652 12.8946 10.5196 12.7071 10.7071C12.5196 10.8946 12.2652 11 12 11H6C5.73478 11 5.48043 10.8946 5.29289 10.7071C5.10536 10.5196 5 10.2652 5 10Z"
      fill={color}
    />
  </svg>
);

export const TimeIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 0C10.8661 0 14 3.1339 14 7C14 10.8661 10.8661 14 7 14C3.1339 14 0 10.8661 0 7C0 3.1339 3.1339 0 7 0ZM7 2.8C6.81435 2.8 6.6363 2.87375 6.50503 3.00503C6.37375 3.1363 6.3 3.31435 6.3 3.5V7C6.30004 7.18564 6.37382 7.36365 6.5051 7.4949L8.6051 9.5949C8.73712 9.72241 8.91394 9.79297 9.09748 9.79137C9.28102 9.78978 9.45659 9.71616 9.58637 9.58637C9.71616 9.45659 9.78978 9.28102 9.79137 9.09748C9.79297 8.91394 9.72241 8.73712 9.5949 8.6051L7.7 6.7102V3.5C7.7 3.31435 7.62625 3.1363 7.49497 3.00503C7.3637 2.87375 7.18565 2.8 7 2.8Z"
      fill={color}
      fill-opacity="0.61"
    />
  </svg>
);

export const MoreElementIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.44444 7.77778H0.777778C0.571498 7.77778 0.373667 7.85972 0.227806 8.00558C0.0819442 8.15145 0 8.34928 0 8.55556V13.2222C0 13.4285 0.0819442 13.6263 0.227806 13.7722C0.373667 13.9181 0.571498 14 0.777778 14H5.44444C5.65072 14 5.84855 13.9181 5.99442 13.7722C6.14028 13.6263 6.22222 13.4285 6.22222 13.2222V8.55556C6.22222 8.34928 6.14028 8.15145 5.99442 8.00558C5.84855 7.85972 5.65072 7.77778 5.44444 7.77778ZM4.66667 12.4444H1.55556V9.33333H4.66667V12.4444ZM13.2222 0H8.55556C8.34928 0 8.15145 0.0819442 8.00558 0.227806C7.85972 0.373667 7.77778 0.571498 7.77778 0.777778V5.44444C7.77778 5.65072 7.85972 5.84855 8.00558 5.99442C8.15145 6.14028 8.34928 6.22222 8.55556 6.22222H13.2222C13.4285 6.22222 13.6263 6.14028 13.7722 5.99442C13.9181 5.84855 14 5.65072 14 5.44444V0.777778C14 0.571498 13.9181 0.373667 13.7722 0.227806C13.6263 0.0819442 13.4285 0 13.2222 0ZM12.4444 4.66667H9.33333V1.55556H12.4444V4.66667ZM13.2222 10.1111H11.6667V8.55556C11.6667 8.34928 11.5847 8.15145 11.4389 8.00558C11.293 7.85972 11.0952 7.77778 10.8889 7.77778C10.6826 7.77778 10.4848 7.85972 10.3389 8.00558C10.1931 8.15145 10.1111 8.34928 10.1111 8.55556V10.1111H8.55556C8.34928 10.1111 8.15145 10.1931 8.00558 10.3389C7.85972 10.4848 7.77778 10.6826 7.77778 10.8889C7.77778 11.0952 7.85972 11.293 8.00558 11.4389C8.15145 11.5847 8.34928 11.6667 8.55556 11.6667H10.1111V13.2222C10.1111 13.4285 10.1931 13.6263 10.3389 13.7722C10.4848 13.9181 10.6826 14 10.8889 14C11.0952 14 11.293 13.9181 11.4389 13.7722C11.5847 13.6263 11.6667 13.4285 11.6667 13.2222V11.6667H13.2222C13.4285 11.6667 13.6263 11.5847 13.7722 11.4389C13.9181 11.293 14 11.0952 14 10.8889C14 10.6826 13.9181 10.4848 13.7722 10.3389C13.6263 10.1931 13.4285 10.1111 13.2222 10.1111ZM5.44444 0H0.777778C0.571498 0 0.373667 0.0819442 0.227806 0.227806C0.0819442 0.373667 0 0.571498 0 0.777778V5.44444C0 5.65072 0.0819442 5.84855 0.227806 5.99442C0.373667 6.14028 0.571498 6.22222 0.777778 6.22222H5.44444C5.65072 6.22222 5.84855 6.14028 5.99442 5.99442C6.14028 5.84855 6.22222 5.65072 6.22222 5.44444V0.777778C6.22222 0.571498 6.14028 0.373667 5.99442 0.227806C5.84855 0.0819442 5.65072 0 5.44444 0ZM4.66667 4.66667H1.55556V1.55556H4.66667V4.66667Z"
      fill={color}
    />
  </svg>
);
export const CopyIon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 1H1V14"
      stroke={color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 5H17V17C17 17.5304 16.7893 18.0391 16.4142 18.4142C16.0391 18.7893 15.5304 19 15 19H7C6.46957 19 5.96086 18.7893 5.58579 18.4142C5.21071 18.0391 5 17.5304 5 17V5Z"
      stroke={color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PlusInCercleIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 11H11V15H9V11H5V9H9V5H11V9H15M10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0Z"
      fill={color}
    />
  </svg>
);

export const LinkCrookedIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8278 12.238L13.533 10.9413L14.8278 9.6465C15.6802 8.78656 16.1573 7.62397 16.1546 6.41313C16.1519 5.20229 15.6698 4.0418 14.8136 3.1856C13.9575 2.32941 12.7971 1.84723 11.5863 1.84458C10.3755 1.84193 9.21297 2.31902 8.35308 3.17146L7.0574 4.4672L5.76264 3.17237L7.0574 1.87755C8.25952 0.675374 9.88993 0 11.59 0C13.29 0 14.9204 0.675374 16.1225 1.87755C17.3247 3.07972 18 4.71022 18 6.41035C18 8.11048 17.3247 9.74098 16.1225 10.9432L14.8278 12.238ZM12.2374 14.8276L10.9426 16.1225C9.74048 17.3246 8.11007 18 6.41002 18C4.70998 18 3.07957 17.3246 1.87745 16.1225C0.67534 14.9203 1.79129e-08 13.2898 0 11.5896C-1.79129e-08 9.88952 0.67534 8.25902 1.87745 7.05685L3.17313 5.76202L4.46789 7.05868L3.17313 8.3535C2.33242 9.21571 1.86524 10.3744 1.87279 11.5787C1.88033 12.7829 2.362 13.9357 3.21344 14.7873C4.06488 15.6389 5.21754 16.1208 6.42172 16.1285C7.6259 16.1362 8.78464 15.6692 9.64692 14.8285L10.9426 13.5337L12.2374 14.8276ZM11.59 5.11461L12.8857 6.41035L6.41002 12.8845L5.11527 11.5896L11.59 5.11461Z"
      fill={color}
    />
  </svg>
);

export const ElectricStationIcon = ({
  size = 30,
  color = "black",
}: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4248 3.33273L12.4327 3.32485L9.50182 0.393939L8.66667 1.22909L10.3291 2.89152C9.58849 3.17515 9.06061 3.88424 9.06061 4.72727C9.06061 4.98594 9.11155 5.24207 9.21054 5.48104C9.30953 5.72002 9.45461 5.93716 9.63752 6.12006C10.0069 6.48945 10.5079 6.69697 11.0303 6.69697C11.3139 6.69697 11.5739 6.63394 11.8182 6.53152V12.2121C11.8182 12.6455 11.4636 13 11.0303 13C10.597 13 10.2424 12.6455 10.2424 12.2121V8.66667C10.2424 7.8 9.53333 7.09091 8.66667 7.09091H7.87879V1.57576C7.87879 0.709091 7.1697 0 6.30303 0H1.57576C0.709091 0 0 0.709091 0 1.57576V14.1818H7.87879V8.27273H9.06061V12.2121C9.06061 12.7345 9.26813 13.2355 9.63752 13.6049C10.0069 13.9743 10.5079 14.1818 11.0303 14.1818C11.5527 14.1818 12.0537 13.9743 12.4231 13.6049C12.7925 13.2355 13 12.7345 13 12.2121V4.72727C13 4.18364 12.7794 3.68727 12.4248 3.33273ZM11.0303 5.51515C10.597 5.51515 10.2424 5.16061 10.2424 4.72727C10.2424 4.29394 10.597 3.93939 11.0303 3.93939C11.4636 3.93939 11.8182 4.29394 11.8182 4.72727C11.8182 5.16061 11.4636 5.51515 11.0303 5.51515ZM3.15152 11.8182V8.27273H1.57576L4.72727 2.36364V6.30303H6.30303L3.15152 11.8182Z"
      fill={color}
    />
  </svg>
);

export const PeoplesIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.7 7.52941C6.70782 7.52941 7.67437 7.13277 8.38701 6.42676C9.09964 5.72074 9.5 4.76317 9.5 3.76471C9.5 2.76624 9.09964 1.80868 8.38701 1.10266C7.67437 0.396637 6.70782 0 5.7 0C4.69218 0 3.72563 0.396637 3.01299 1.10266C2.30036 1.80868 1.9 2.76624 1.9 3.76471C1.9 4.76317 2.30036 5.72074 3.01299 6.42676C3.72563 7.13277 4.69218 7.52941 5.7 7.52941ZM14.25 7.52941C15.0059 7.52941 15.7308 7.23193 16.2653 6.70242C16.7997 6.17291 17.1 5.45473 17.1 4.70588C17.1 3.95704 16.7997 3.23886 16.2653 2.70935C15.7308 2.17983 15.0059 1.88235 14.25 1.88235C13.4941 1.88235 12.7692 2.17983 12.2347 2.70935C11.7003 3.23886 11.4 3.95704 11.4 4.70588C11.4 5.45473 11.7003 6.17291 12.2347 6.70242C12.7692 7.23193 13.4941 7.52941 14.25 7.52941ZM2.1375 9.41176C1.5706 9.41176 1.02692 9.63487 0.626059 10.032C0.2252 10.4291 0 10.9678 0 11.5294V11.7647C0 11.7647 0 16 5.7 16C11.4 16 11.4 11.7647 11.4 11.7647V11.5294C11.4 10.9678 11.1748 10.4291 10.7739 10.032C10.3731 9.63487 9.8294 9.41176 9.2625 9.41176H2.1375ZM14.25 14.5882C13.1375 14.5882 12.2854 14.4179 11.6327 14.1572C12.0127 13.5221 12.2511 12.8139 12.3319 12.08C12.3412 11.9908 12.3472 11.9014 12.35 11.8118V11.5294C12.3512 10.7409 12.0441 9.98262 11.4931 9.41365L11.59 9.41176H16.91C17.4643 9.41176 17.9959 9.62992 18.3879 10.0182C18.7798 10.4065 19 10.9332 19 11.4824C19 11.4824 19 14.5882 14.25 14.5882Z"
      fill={color}
    />
  </svg>
);

export const BuildingIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8 2.18182V14H2.2V2.18182H11.8ZM4.6252 5.72727H5.8252V4.54545H4.6252V5.72727ZM8.2 5.72727H9.4V4.54545H8.2V5.72727ZM4.6252 9.27273H5.8252V8.09091H4.6252V9.27273ZM5.8252 14H8.2252V11.6364H5.8252V14ZM8.2 9.27273H9.4V8.09091H8.2V9.27273ZM1 2.18182H13V1H1V2.18182Z"
      stroke={color}
      stroke-width="2"
    />
  </svg>
);

export const AdminIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 20C11.6167 20 10.4377 19.5123 9.463 18.537C8.48833 17.5617 8.00067 16.3827 8 15C7.99933 13.6173 8.487 12.4383 9.463 11.463C10.439 10.4877 11.618 10 13 10C14.382 10 15.5613 10.4877 16.538 11.463C17.5147 12.4383 18.002 13.6173 18 15C17.998 16.3827 17.5103 17.562 16.537 18.538C15.5637 19.514 14.3847 20.0013 13 20ZM8 20C5.68333 19.4167 3.77067 18.0873 2.262 16.012C0.753334 13.9367 -0.000666225 11.6327 4.41696e-07 9.1V3L8 0L16 3V8.675C15.5667 8.45833 15.079 8.29167 14.537 8.175C13.995 8.05833 13.4827 8 13 8C11.0667 8 9.41667 8.68333 8.05 10.05C6.68333 11.4167 6 13.0667 6 15C6 16.0333 6.196 16.9667 6.588 17.8C6.98 18.6333 7.47567 19.3583 8.075 19.975C8.05833 19.975 8.046 19.9793 8.038 19.988C8.03 19.9967 8.01733 20.0007 8 20ZM13 15C13.4167 15 13.771 14.8543 14.063 14.563C14.355 14.2717 14.5007 13.9173 14.5 13.5C14.4993 13.0827 14.3537 12.7287 14.063 12.438C13.7723 12.1473 13.418 12.0013 13 12C12.582 11.9987 12.228 12.1447 11.938 12.438C11.648 12.7313 11.502 13.0853 11.5 13.5C11.498 13.9147 11.644 14.269 11.938 14.563C12.232 14.857 12.586 15.0027 13 15ZM13 18C13.5167 18 13.9917 17.879 14.425 17.637C14.8583 17.395 15.2083 17.0743 15.475 16.675C15.1083 16.4583 14.7167 16.2917 14.3 16.175C13.8833 16.0583 13.45 16 13 16C12.55 16 12.1167 16.0583 11.7 16.175C11.2833 16.2917 10.8917 16.4583 10.525 16.675C10.7917 17.075 11.1417 17.396 11.575 17.638C12.0083 17.88 12.4833 18.0007 13 18Z"
      fill={color}
    />
  </svg>
);

export const ProfilIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C9.06087 0 10.0783 0.421427 10.8284 1.17157C11.5786 1.92172 12 2.93913 12 4C12 5.06087 11.5786 6.07828 10.8284 6.82843C10.0783 7.57857 9.06087 8 8 8C6.93913 8 5.92172 7.57857 5.17157 6.82843C4.42143 6.07828 4 5.06087 4 4C4 2.93913 4.42143 1.92172 5.17157 1.17157C5.92172 0.421427 6.93913 0 8 0ZM8 16C8 16 16 16 16 14C16 11.6 12.1 9 8 9C3.9 9 0 11.6 0 14C0 16 8 16 8 16Z"
      fill={color}
    />
  </svg>
);

export const BellIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 17V18H0V17L2 15V9C2 5.9 4.03 3.17 7 2.29V2C7 1.46957 7.21071 0.960859 7.58579 0.585786C7.96086 0.210714 8.46957 0 9 0C9.53043 0 10.0391 0.210714 10.4142 0.585786C10.7893 0.960859 11 1.46957 11 2V2.29C13.97 3.17 16 5.9 16 9V15L18 17ZM11 19C11 19.5304 10.7893 20.0391 10.4142 20.4142C10.0391 20.7893 9.53043 21 9 21C8.46957 21 7.96086 20.7893 7.58579 20.4142C7.21071 20.0391 7 19.5304 7 19"
      fill={color}
    />
  </svg>
);

export const VisibilityOffIcon = ({
  size = 25,
  color = "gray",
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    viewBox="0 0 22 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 4C13.76 4 16 6.24 16 9C16 9.65 15.87 10.26 15.64 10.83L18.56 13.75C20.07 12.49 21.26 10.86 21.99 9C20.26 4.61 15.99 1.5 10.99 1.5C9.59 1.5 8.25 1.75 7.01 2.2L9.17 4.36C9.74 4.13 10.35 4 11 4ZM1 1.27L3.28 3.55L3.74 4.01C2.06842 5.30786 0.776644 7.03138 0 9C1.73 13.39 6 16.5 11 16.5C12.55 16.5 14.03 16.2 15.38 15.66L15.8 16.08L18.73 19L20 17.73L2.27 0L1 1.27ZM6.53 6.8L8.08 8.35C8.03 8.56 8 8.78 8 9C8 10.66 9.34 12 11 12C11.22 12 11.44 11.97 11.65 11.92L13.2 13.47C12.53 13.8 11.79 14 11 14C8.24 14 6 11.76 6 9C6 8.21 6.2 7.47 6.53 6.8ZM10.84 6.02L13.99 9.17L14.01 9.01C14.01 7.35 12.67 6.01 11.01 6.01L10.84 6.02Z"
      fill={color}
    />
  </svg>
);

export const VisibilityIcon = ({
  size = 25,
  color = "gray",
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    viewBox="0 0 22 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 12C12.25 12 13.3127 11.5627 14.188 10.688C15.0633 9.81333 15.5007 8.75067 15.5 7.5C15.4993 6.24933 15.062 5.187 14.188 4.313C13.314 3.439 12.2513 3.00133 11 3C9.74867 2.99867 8.68633 3.43633 7.813 4.313C6.93967 5.18967 6.502 6.252 6.5 7.5C6.498 8.748 6.93567 9.81067 7.813 10.688C8.69033 11.5653 9.75267 12.0027 11 12ZM11 10.2C10.25 10.2 9.61267 9.93733 9.088 9.412C8.56333 8.88667 8.30067 8.24933 8.3 7.5C8.29933 6.75067 8.562 6.11333 9.088 5.588C9.614 5.06267 10.2513 4.8 11 4.8C11.7487 4.8 12.3863 5.06267 12.913 5.588C13.4397 6.11333 13.702 6.75067 13.7 7.5C13.698 8.24933 13.4357 8.887 12.913 9.413C12.3903 9.939 11.7527 10.2013 11 10.2ZM11 15C8.56667 15 6.35 14.321 4.35 12.963C2.35 11.605 0.9 9.784 0 7.5C0.9 5.21667 2.35 3.396 4.35 2.038C6.35 0.680001 8.56667 0.000667157 11 4.90196e-07C13.4333 -0.000666176 15.65 0.678667 17.65 2.038C19.65 3.39733 21.1 5.218 22 7.5C21.1 9.78333 19.65 11.6043 17.65 12.963C15.65 14.3217 13.4333 15.0007 11 15Z"
      fill="black"
    />
  </svg>
);

export const ElectricCarPlugCC = ({
  color = "#313131",
  size = 15,
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.25 4.88889C42.5 8.55556 45 13.6889 45 19.5556C45 30.3111 36 39.1111 25 39.1111C14 39.1111 5 30.3111 5 19.5556C5 13.6889 7.75 8.55556 11.75 4.88889H38.25ZM40 0H10L8.5 1.22222C3 5.86667 0 12.4667 0 19.5556C0 33 11.25 44 25 44C38.75 44 50 33 50 19.5556C50 12.4667 47 5.86667 41.5 1.22222L40 0ZM27.5 11C27.5 12.9556 29.25 14.6667 31.25 14.6667C33.25 14.6667 35 12.9556 35 11C35 9.04444 33.25 7.33333 31.25 7.33333C29.25 7.33333 27.5 9.04444 27.5 11ZM15 11C15 12.9556 16.75 14.6667 18.75 14.6667C20.75 14.6667 22.5 12.9556 22.5 11C22.5 9.04444 20.75 7.33333 18.75 7.33333C16.75 7.33333 15 9.04444 15 11ZM12.5 24.4444C15.25 24.4444 17.5 22.2444 17.5 19.5556C17.5 16.8667 15.25 14.6667 12.5 14.6667C9.75 14.6667 7.5 16.8667 7.5 19.5556C7.5 22.2444 9.75 24.4444 12.5 24.4444ZM23.75 29.3333C23.75 26.6444 21.5 24.4444 18.75 24.4444C16 24.4444 13.75 26.6444 13.75 29.3333C13.75 32.0222 16 34.2222 18.75 34.2222C21.5 34.2222 23.75 32.0222 23.75 29.3333ZM25 24.4444C27.75 24.4444 30 22.2444 30 19.5556C30 16.8667 27.75 14.6667 25 14.6667C22.25 14.6667 20 16.8667 20 19.5556C20 22.2444 22.25 24.4444 25 24.4444ZM36.25 29.3333C36.25 26.6444 34 24.4444 31.25 24.4444C28.5 24.4444 26.25 26.6444 26.25 29.3333C26.25 32.0222 28.5 34.2222 31.25 34.2222C34 34.2222 36.25 32.0222 36.25 29.3333ZM42.5 19.5556C42.5 16.8667 40.25 14.6667 37.5 14.6667C34.75 14.6667 32.5 16.8667 32.5 19.5556C32.5 22.2444 34.75 24.4444 37.5 24.4444C40.25 24.4444 42.5 22.2444 42.5 19.5556Z"
        fill={color}
      />
    </svg>
  );
};

export const SearchIcon = ({ color = "#313131", size = 15 }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6 18L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13C4.68333 13 3.146 12.3707 1.888 11.112C0.63 9.85333 0.000667196 8.316 5.29101e-07 6.5C-0.000666138 4.684 0.628667 3.14667 1.888 1.888C3.14733 0.629333 4.68467 0 6.5 0C8.31533 0 9.853 0.629333 11.113 1.888C12.373 3.14667 13.002 4.684 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L18 16.6L16.6 18ZM6.5 11C7.75 11 8.81267 10.5627 9.688 9.688C10.5633 8.81333 11.0007 7.75067 11 6.5C10.9993 5.24933 10.562 4.187 9.688 3.313C8.814 2.439 7.75133 2.00133 6.5 2C5.24867 1.99867 4.18633 2.43633 3.313 3.313C2.43967 4.18967 2.002 5.252 2 6.5C1.998 7.748 2.43567 8.81067 3.313 9.688C4.19033 10.5653 5.25267 11.0027 6.5 11Z"
      fill={color}
    />
  </svg>
);

export const TrashIcon = ({ color = "#313131", size = 15 }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 1H10.5L9.5 0H4.5L3.5 1H0V3H14M1 16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H11C11.5304 18 12.0391 17.7893 12.4142 17.4142C12.7893 17.0391 13 16.5304 13 16V4H1V16Z"
      fill={color}
    />
  </svg>
);

export const EditSheetIcon = ({ color = "#313131", size = 15 }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7653 0.852061C11.9279 0.852061 13.0045 1.21987 13.8845 1.84785L5.69035 10.0411C5.60467 10.1239 5.53633 10.2229 5.48931 10.3323C5.44229 10.4418 5.41755 10.5595 5.41651 10.6786C5.41548 10.7977 5.43817 10.9159 5.48328 11.0261C5.52839 11.1364 5.595 11.2365 5.67923 11.3208C5.76347 11.405 5.86363 11.4716 5.97388 11.5167C6.08413 11.5618 6.20226 11.5845 6.32138 11.5835C6.4405 11.5825 6.55822 11.5577 6.66767 11.5107C6.77712 11.4637 6.87611 11.3953 6.95886 11.3096L15.153 3.11546C15.8005 4.02668 16.1482 5.11688 16.1479 6.23471V15.2058C16.1479 15.6816 15.9589 16.138 15.6224 16.4745C15.2859 16.811 14.8296 17 14.3537 17H1.79422C1.31836 17 0.861994 16.811 0.525513 16.4745C0.189033 16.138 0 15.6816 0 15.2058V2.64628C0 2.17042 0.189033 1.71405 0.525513 1.37757C0.861994 1.04109 1.31836 0.852061 1.79422 0.852061H10.7653ZM16.7373 0.262661C16.9055 0.430893 17 0.659035 17 0.896916C17 1.1348 16.9055 1.36294 16.7373 1.53117L15.1521 3.11546C14.8032 2.62465 14.3745 2.19585 13.8836 1.84695L15.4679 0.262661C15.6362 0.0944792 15.8643 0 16.1022 0C16.3401 0 16.5691 0.0944792 16.7373 0.262661Z"
      fill={color}
    />
  </svg>
);

export const InfoIcon = ({ color = "#313131", size = 15 }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 10 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.43202 0C8.77202 0 9.44202 0.912 9.44202 1.957C9.44202 3.262 8.27802 4.469 6.76302 4.469C5.49402 4.469 4.75402 3.719 4.78902 2.479C4.78902 1.436 5.67002 0 7.43202 0ZM3.30902 20C2.25102 20 1.47602 19.348 2.21602 16.476L3.43002 11.384C3.64102 10.57 3.67602 10.243 3.43002 10.243C3.11302 10.243 1.74102 10.805 0.928024 11.36L0.400024 10.48C2.97202 8.294 5.93102 7.013 7.20102 7.013C8.25802 7.013 8.43402 8.286 7.90602 10.243L6.51502 15.595C6.26902 16.54 6.37402 16.866 6.62102 16.866C6.93802 16.866 7.97802 16.474 9.00002 15.659L9.60003 16.473C7.09803 19.02 4.36502 20 3.30902 20Z"
      fill={color}
    />
  </svg>
);

export const PlugIcon = ({ color = "#313131", size = 15 }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 3H6.5V0H5.5V3H2.5V0H1.5V3H1C0.734784 3 0.48043 3.10536 0.292893 3.29289C0.105357 3.48043 0 3.73478 0 4V7C0.0019528 7.97335 0.358304 8.91267 1.00244 9.64239C1.64658 10.3721 2.53442 10.8423 3.5 10.965V14H4.5V10.965C5.46558 10.8423 6.35342 10.3721 6.99756 9.64239C7.6417 8.91267 7.99805 7.97335 8 7V4C8 3.73478 7.89464 3.48043 7.70711 3.29289C7.51957 3.10536 7.26522 3 7 3Z"
      fill={color}
    />
  </svg>
);

export const DownloadIcon = ({ color = "#313131", size = 15 }: IconProps) => (
  <svg
    width={size}
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 12L3 7L4.4 5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12ZM2 16C1.45 16 0.979333 15.8043 0.588 15.413C0.196666 15.0217 0.000666667 14.5507 0 14V11H2V14H14V11H16V14C16 14.55 15.8043 15.021 15.413 15.413C15.0217 15.805 14.5507 16.0007 14 16H2Z"
      fill={color}
    />
  </svg>
);

export const ChartInBox = ({ color = "#313131", size = 15 }: IconProps) => (
  <svg width={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.464 1.464C0 2.93 0 5.286 0 10C0 14.714 0 17.071 1.464 18.535C2.93 20 5.286 20 10 20C14.714 20 17.071 20 18.535 18.535C20 17.072 20 14.714 20 10C20 5.286 20 2.929 18.535 1.464C17.072 0 14.714 0 10 0C5.286 0 2.929 0 1.464 1.464ZM15.576 8.48C15.6977 8.32662 15.7546 8.13173 15.7345 7.93697C15.7145 7.7422 15.619 7.56301 15.4686 7.43766C15.3182 7.31232 15.1247 7.25076 14.9295 7.26615C14.7344 7.28153 14.5529 7.37264 14.424 7.52L12.627 9.676C12.257 10.121 12.028 10.392 11.841 10.561C11.7921 10.6084 11.7373 10.6494 11.678 10.683L11.667 10.688L11.659 10.684L11.656 10.683C11.5963 10.6495 11.5412 10.6085 11.492 10.561C11.305 10.391 11.077 10.121 10.706 9.676L10.414 9.326C10.086 8.931 9.789 8.576 9.513 8.326C9.212 8.054 8.833 7.812 8.333 7.812C7.833 7.812 7.455 8.054 7.153 8.326C6.877 8.576 6.581 8.931 6.253 9.326L4.423 11.52C4.35997 11.5957 4.31246 11.6831 4.2832 11.7772C4.25393 11.8712 4.24348 11.9701 4.25244 12.0682C4.27054 12.2664 4.3666 12.4492 4.5195 12.5765C4.6724 12.7038 4.8696 12.7652 5.06774 12.7471C5.26587 12.729 5.4487 12.6329 5.576 12.48L7.373 10.324C7.743 9.879 7.972 9.608 8.159 9.439C8.20792 9.39156 8.26269 9.35056 8.322 9.317L8.329 9.314L8.333 9.312L8.344 9.317C8.40366 9.35049 8.45878 9.39149 8.508 9.439C8.695 9.609 8.923 9.879 9.294 10.324L9.586 10.674C9.915 11.069 10.211 11.424 10.487 11.674C10.788 11.946 11.167 12.188 11.667 12.188C12.167 12.188 12.545 11.946 12.847 11.674C13.123 11.424 13.419 11.069 13.747 10.674L15.576 8.48Z" fill={color}/>
</svg>

)

export const ExitIcon = ({ color = "#313131", size = 15 }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 4L13.59 5.41L16.17 8H6V10H16.17L13.59 12.58L15 14L20 9M2 2H10V0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H10V16H2V2Z"
      fill={color}
    />
  </svg>
);

export const EFPlugIcon = ({ color = "#313131", size = 15 }) => (
  <svg
    width={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 8.5C5.89782 8.5 6.27936 8.65804 6.56066 8.93934C6.84196 9.22064 7 9.60218 7 10C7 10.3978 6.84196 10.7794 6.56066 11.0607C6.27936 11.342 5.89782 11.5 5.5 11.5C4.66 11.5 4 10.83 4 10C4 9.60218 4.15804 9.22064 4.43934 8.93934C4.72064 8.65804 5.10218 8.5 5.5 8.5ZM14.5 8.5C14.8978 8.5 15.2794 8.65804 15.5607 8.93934C15.842 9.22064 16 9.60218 16 10C16 10.3978 15.842 10.7794 15.5607 11.0607C15.2794 11.342 14.8978 11.5 14.5 11.5C14.1022 11.5 13.7206 11.342 13.4393 11.0607C13.158 10.7794 13 10.3978 13 10C13 9.60218 13.158 9.22064 13.4393 8.93934C13.7206 8.65804 14.1022 8.5 14.5 8.5ZM2.22 0H17.78C19 0 20 1 20 2.22V17.78C20 18.3688 19.7661 18.9334 19.3498 19.3498C18.9334 19.7661 18.3688 20 17.78 20H2.22C1 20 0 19 0 17.78V2.22C0 1.63122 0.233892 1.06655 0.650223 0.650223C1.06655 0.233892 1.63122 0 2.22 0ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2Z"
      fill={color}
    />
  </svg>
);
export const JWayIcon = ({
  size = 30,
  color = "black",
  type,
}: IconProps & { type: IconType }) => {
  switch (type) {
    case "home":
      return <HomeIcon size={size} color={color} />;
    case "coin":
      return <CoinIcon size={size} color={color} />;
    case "electricStation":
      return <ElectricStationIcon size={size} color={color} />;
    case "peoples":
      return <PeoplesIcon size={size} color={color} />;
    case "building":
      return <BuildingIcon size={size} color={color} />;
    case "profil":
      return <ProfilIcon size={size} color={color} />;
    case "bell":
      return <BellIcon size={size} color={color} />;
    case "link-crooked":
      return <LinkCrookedIcon size={size} color={color} />;
    case "copy":
      return <CopyIon size={size} color={color} />;
    case "visibility-off":
      return <VisibilityOffIcon size={size} color={color} />;
    case "admin":
      return <AdminIcon size={size} color={color} />;
    case "visibility":
      return <VisibilityIcon size={size} color={color} />;
    case "thunder":
      return <ThunderIcon size={size} color={color} />;
    case "plus-in-cercle":
      return <PlusInCercleIcon size={size} color={color} />;
    case "electric-car-plug":
      return <ElectricCarPlugCC size={size} color={color} />;
    case "ship":
      return <ShipIcon size={size} color={color} />;
    case "search":
      return <SearchIcon size={size} color={color} />;
    case "trash":
      return <TrashIcon size={size} color={color} />;
    case "edit-sheet":
      return <EditSheetIcon size={size} color={color} />;
    case "prohibited":
      return <ProhibitedIcon size={size} color={color} />;
    case "more-element":
      return <MoreElementIcon size={size} color={color} />;
    case "time":
      return <TimeIcon size={size} color={color} />;
    case "info":
      return <InfoIcon size={size} color={color} />;
    case "filter":
      return <FilterIcon size={size} color={color} />;
    case "cross":
      return <CrossIcon size={size} color={color} />;
    case "people-star":
      return <PeopleStarIcon size={size} color={color} />;
    case "wallet":
      return <WalletIcon size={size} color={color} />;
    case "exchange":
      return <ExchangeIcon size={size} color={color} />;
    case "plus":
      return <PlusIcon size={size} color={color} />;
    case "arrow-right":
      return <ArrowRightIcon size={size} color={color} />;
    case "plug-icon":
      return <PlugIcon size={size} color={color} />;
    case "download-icon":
      return <DownloadIcon size={size} color={color} />;
    case "car-plug-ccs2":
      return <CarPlugIconCCS2 size={size} color={color} />;
    case "car-plug-type-2":
      return <CarPlugIconType2 size={size} color={color} />;
    case "exit":
      return <ExitIcon size={size} color={color} />;
    case "ef-plug":
      return <EFPlugIcon size={size} color={color} />;
    case "chart-in-box":
      return <ChartInBox size={size} color={color} />;

    default:
      return <HomeIcon size={size} color={color} />;
  }
};
